<template>
  <div class="font-medium text-xl">
    {{ $t("Notifications") }}
  </div>
  <div v-for="notification_item in notifications" :key="notification_item.id" class="my-3">
    <div class="flex items-center space-x-2">
      <img
        v-if="notification_item.user.avatar"
        class="inline-block rounded-full h-9 w-9 object-cover"
        :src="notification_item.user.avatar"
        alt="">
      <Avatar
        v-else
        :radius="26"
        :hover-effect="true"
        :first-name="notification_item.user.first_name"
        :last-name="notification_item.user.last_name" />

      <div>
        <div>{{ notification_item.description }}</div>
        <div class="text-common-grey text-sm">
          {{ notification_item.date }}
        </div>
      </div>
    </div>
  </div>
  <div class="font-medium text-xl mt-8">
    {{ $t("Analytics") }}
  </div>
</template>

<script>
import Avatar from "@/components/shared/Avatar.vue"

export default {
  components: { Avatar },
  props: {},
  emits: [],
  data() {
    return {
      notifications: [
        {
          id: 1,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 2,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 3,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 4,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 5,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 6,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 7,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 8,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 9,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        },
        {
          id: 10,
          date: "3 days ago",
          description: "Manuel Assad has been added as an editor",
          user: { first_name: "Manuel", last_name: "Assad" }
        }
      ]
    }
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
